import React,{useState} from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { IAppPropsWithRoute } from '../../common/types';

import {
    Box,
    Button,
    Grid,
} from '@material-ui/core';
import { useStyles } from "./styles";
import * as Icons from "./iconComponents";
import { format } from 'date-fns';
import IndexedDb from './IndexedDb';
import { getData } from '../Schedule/helpers/transferScheduleHelpers';
import moment from 'moment';
import * as fs from "fs";
import { forEach } from 'lodash';
import { DeviceHubSharp } from '@material-ui/icons';
import { RootState } from "../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import api from '../../store/api';
import { pcrstate, setpcrstate } from '../../store/modules/PcrSlice';
interface PcrWidgetProps extends IAppPropsWithRoute {

};

interface Pcr {
    pcrId: string,
    name: string,
    started_time: string,
};
interface db {
    name: string,
    patname:string|null,
    surname:string|null,
    delete:boolean,
    time:Date
};
const PcrWidget: React.FC<PcrWidgetProps> = () => {
    const classes = useStyles();
    const history = useHistory();
    const pcr = useSelector(pcrstate)
    const indexedDb="";
    const [loading, setLoading] = React.useState(false);
    const [pcrList, setPcrList] = React.useState<Pcr[]>([]);
    const [idb, setidb] = React.useState<db[]>();
    const [CustGivenNameIdb, setCustGivenNameIdb] = useState<String>("");
    const [DOBIdb, setDOBIdb] = useState<Date>(new Date());
    const { authStore } = useSelector((state: RootState) => state);
    const SMAUser = useState(authStore.data?.IsSMAUser);
    const location = useState(authStore.data?.location);  
    const dispatch = useDispatch();

    let dbs:any=[];   
    React.useEffect(() => {
        if (navigator.onLine) {
            console.log("online");
          } else {
            console.log("offline");
          }
    }, [])

    React.useEffect(() => {
        let db:any = null;
        // @ts-ignore:next-line
        let promise =  window.indexedDB.databases();
        // @ts-ignore:next-line
         promise.then((databases) => {
            for(let i=0;i<databases.length;i++)
            {               
                var val =databases[i].name;
                db = val;                              
                if(db ==="" || db == undefined || db === null || db === "null")
                {
                    const indexedDb = new IndexedDb(db);              
                    const DBDeleteRequest = window.indexedDB.deleteDatabase(db);
                }
                else
                {
                    let res = dbname(db);  
                }               
            }
        })       
    }, [])

    const handleAdd = async (): Promise<void> => {        
        setLoading(a => true);
        localStorage.setItem("PatientDB",format(new Date(),"dd-MM-yyyy HH:mm:ss"));
        var val = localStorage.getItem("Indexdb");        
        if(val)
        {
            val = val+","+format(new Date(),"dd-MM-yyyy HH:mm:ss");
            localStorage.setItem("Indexdb",val)           
        }
        else{
            localStorage.setItem("Indexdb",format(new Date(),"dd-MM-yyyy HH:mm:ss"))          
        }
        localStorage.removeItem("Customerid")
        if(!SMAUser[0])
        {
            await loadCustomer();
        }
        dispatch(setpcrstate({ name: "ValidateAllFields", value: true }));
        setLoading(a => false);
        history.push("/patientCareRecord/add");
    }

    const loadCustomer = async (): Promise<void> => {
        try {
            if (authStore.data?.IsCustomer) {     
                var cusid = authStore.data.CustomerId;
                localStorage.setItem("Customerid",cusid||"")              
            }
            else {
                const res = await api.getPCRCustomer('locationid=' + location[0], '');
                if (res.result) {
                    localStorage.setItem("Customerid", res.result)
                }
            }
          
          }
        catch (error) {
            //console.error(error);
        }
    }

    const handleEdit =async (id: any): Promise<void> => {
        setLoading(a => true);
        localStorage.setItem("PatientDB",(id));
        if(!SMAUser[0])
        {
            await loadCustomer();
        }
        setLoading(a => false);
        history.push("/patientCareRecord/edit/" + id);
    }
    
    const dbname = async (name:any): Promise<void>=>{
        const indexedDb = new IndexedDb(name);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);               
        let val =  await indexedDb.getValues('Patientidentification','CustGivenName');
        let valN =  await indexedDb.getValues('Patientidentification','CustSurName');
        let Delete =  await indexedDb.getValues('Patientidentification','Delete');
        let Useremail = await indexedDb.getValues('Patientidentification','Useremail');
        var today = new Date();
        if(Delete!==true && Useremail === authStore.data?.email)
        {
            dbs.push({
                name:name,
                patname:val,    
                surname:valN,
                delete:Delete,
               time:timeToAgoString(moment(name,"DD/MM/YYYY HH:mm:ss"))
            })
            dbs.sort((a:any, b:any) => {
                return b.name.localeCompare(a.name);
            });
           if(dbs.length >0)
           {       
            setidb(old => [...dbs]);
           }
        }
        return dbs;
    }
      
    const timeToAgoString = (date: any): string => {
        const timenow = moment();
        const diffMin = Math.floor(moment.duration(timenow.diff(moment(date))).asMinutes());
        if (diffMin <= 0) {
          return "Just Now";
        } else {
          const diffHours = Math.floor(diffMin / 60);
          const diffDays = Math.floor(diffHours / 24);
          return `${diffDays > 0 ? diffDays + "d " : ""}${diffHours > 0 ? (diffHours % 20) + "h " : ""}${diffMin % 60 > 0 ? (diffMin % 60) + "m" : ""} ago`;
        }
      };
    return (
        <div className={classes.root}>
            {(idb && idb.filter(x=>x.delete!==true)) ? (
                <>
                    <Box className={classes.pcrListMain}>
                        <Grid container spacing={0} className={classes.pcrListHeader} id="pcrFixedTop">
                            <Grid item xs={6} sm={"auto"}>
                                <div className={"text1"}>
                                    You have {(idb.length)} PCRs in progress
                                </div>
                            </Grid>
                            <Grid item xs={"auto"} sm={"auto"}>
                                <Button className={classes.yellowBtn} onClick={handleAdd} disabled={loading}>
                                    Start New PCR
                                </Button>                           
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} className={classes.pcrListSection}>
                            {idb.filter((x)=>x.delete !== true).map((item, index) => (                               
                            <Grid item key={index} xs={12} sm={4} md={3} style={loading ? {pointerEvents: "none", opacity: "0.4"} : {}}>
                                <Box onClick={(e) => handleEdit((item.name))} className={classes.pcrListItem}>
                                    <div className={"icon"}>
                                        <Icons.UserListIcon />
                                    </div>
                                    <div className={"title"}>
                                        {(item.patname !=null && item.patname!="")|| (item.surname!==null && item.surname!=="") ? 
                                        (item.patname !== null ? item.patname :"") +" "+ (item.surname !==null ? item.surname:"") :"No Name"}
                                    </div>
                                    <div className={"desc"}>
                                        Started { item.time  }
                                    </div>
                                </Box>
                            </Grid>
                            ))}
                        </Grid>
                    </Box>
                </>
            ) : (
                <EmptyList handleAdd={handleAdd} loading={loading}/>
            )}
        </div>
    );
}

const EmptyList: React.FC<any> = (props) => {
    const classes = useStyles();
    
    return (
        <>
            <Grid container direction="column" className={classes.pcrListEmptyMain}>
                <Grid item xs={8} sm={"auto"}>
                    <div className={"line1"}>
                        You have no Patient Care Records in progress
                    </div>
                    <div className={"line2"}>
                        Start a PCR for every patient transport or medical incident.
                    </div>
                    <Button className={classes.yellowBtn} onClick={props.handleAdd} disabled={props.loading}>
                        Start New PCR
                    </Button>
                </Grid>
            </Grid>
        </>
    );
}

export default React.memo(withRouter(PcrWidget));